import axiosStatic from 'axios';
import { store } from '~/store';

export const axios = axiosStatic.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: (status) => status < 300,
});

axios.interceptors.request.use(async (config) => {
  const { access_token } = store.getState().account;
  if (access_token) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }
  return config;
});
